import React from 'react';
import {connect} from 'react-redux';
import AdditionalCharges from './AdditionalCharges';

const AdditionalChargesBlock = ({data, context, additionalCharges, currentSubscriber}) => {
  return <AdditionalCharges additionalCharges={additionalCharges} data={data} context={context} currentSubscriber={currentSubscriber} />;
};

const mapStateToProps = (state) => {
  return {
    additionalCharges: state.cellcomTransactionSummary.transactionData.additionalCharges,
    currentSubscriber: state.cellcomTransactionSummary.callular,
  };
};

export default connect(mapStateToProps, null)(AdditionalChargesBlock);
